import { PageHero, SoftLink } from "@/components/ui/PageHero";
import { ROUTES } from "@/lib/routes";
import { Link } from "react-router-dom";

export default function InstitutionsPage() {
	return (
		<div className="pb-16">
			<PageHero
				eyebrow="Institutions"
				title="Enterprise rails"
				subtitle="Treasury transparency, liquidity inventory, and agent APIs for desks and integrators."
			/>
			<div className="container mx-auto max-w-lg space-y-4 px-4">
				<div className="glass-panel space-y-3 p-6 text-sm">
					<p className="text-muted-foreground">
						MotokoDollar is designed for human wallets and agent integrators on
						Internet Computer. Institutions can:
					</p>
					<ul className="list-inside list-disc space-y-1 text-muted-foreground">
						<li>Monitor surplus and sleeves on the Treasury page</li>
						<li>Read fixed-price inventory on Liquidity</li>
						<li>Integrate via Agent Layer API keys and skills</li>
						<li>Verify TVL via certified analytics</li>
					</ul>
					<div className="flex flex-wrap gap-2 pt-2">
						<Link
							to={ROUTES.treasury}
							className="rounded-xl bg-primary px-4 py-2 text-xs font-semibold text-primary-foreground"
						>
							Treasury
						</Link>
						<Link
							to={ROUTES.liquidity}
							className="rounded-xl border border-border px-4 py-2 text-xs font-semibold"
						>
							Liquidity
						</Link>
						<Link
							to={ROUTES.agents}
							className="rounded-xl border border-border px-4 py-2 text-xs font-semibold"
						>
							Agents
						</Link>
						<SoftLink to={ROUTES.docs}>Docs</SoftLink>
					</div>
				</div>
			</div>
		</div>
	);
}
